// ── Screen-reader announcer ─────────────────────────
function apAnnounce(message) {
  var region = document.getElementById('a11y-status');
  if (!region) return;
  // Clearing first forces assistive tech to re-read an identical message
  region.textContent = '';
  setTimeout(function () { region.textContent = message; }, 60);
}

// ── Shopper-safe error text ─────────────────────────
// A fetch() rejection carries the BROWSER's developer string — "Failed to
// fetch" (Chrome), "Load failed" (iOS Safari), "NetworkError when attempting
// to fetch resource." (Firefox), "The Internet connection appears to be
// offline." (Safari). Those mean nothing to a shopper, so only the SERVER's
// own `description` (e.g. "You can only add 24 of this item to your cart") is
// passed through; anything else falls back to the caller's friendly text.
function apFriendlyError(raw, fallback) {
  if (raw && !/^(Failed to fetch|Load failed|NetworkError|The Internet connection appears)/i.test(raw)) {
    return raw;
  }
  return fallback;
}

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav hamburger toggle ──
  var hamburger = document.getElementById('nav-hamburger');
  var navLinks  = document.getElementById('nav-links');
  if (hamburger && navLinks) {
    var setNavState = function (open) {
      navLinks.classList.toggle('open', open);
      hamburger.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      hamburger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      // Hand focus into the menu on open. The panel sits BEFORE the button in
      // the DOM, so without this Tab moves PAST the menu just revealed and it
      // is only reachable via Shift+Tab. Escape still returns focus below.
      if (open) {
        var firstLink = navLinks.querySelector('a');
        if (firstLink) firstLink.focus();
      }
    };
    hamburger.addEventListener('click', function () {
      setNavState(!navLinks.classList.contains('open'));
    });
    // Close on link click
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setNavState(false); });
    });
    // Close on Escape, and return focus to the button
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navLinks.classList.contains('open')) {
        setNavState(false);
        hamburger.focus();
      }
    });
  }

  // ── Qty controls ──
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  var qtyInput = document.querySelector('.qty-input');
  var qtyNum   = document.querySelector('.qty-num');
  if (qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var el = qtyInput || qtyNum;
      if (!el) return;
      var val = parseInt(qtyInput ? qtyInput.value : qtyNum.textContent, 10);
      if (val > 1) {
        if (qtyInput) { qtyInput.value = val - 1; } else { qtyNum.textContent = val - 1; }
        apAnnounce('Quantity ' + (val - 1));
      }
    });
    qtyPlus.addEventListener('click', function () {
      var el = qtyInput || qtyNum;
      if (!el) return;
      var val = parseInt(qtyInput ? qtyInput.value : qtyNum.textContent, 10);
      if (qtyInput) { qtyInput.value = val + 1; } else { qtyNum.textContent = val + 1; }
      apAnnounce('Quantity ' + (val + 1));
    });
  }

  // ── Benefits scroll-reveal ──
  (function () {
    var cards = document.querySelectorAll('.benefit-card.reveal');
    if (!cards.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (card) { observer.observe(card); });
  })();

  // ── Impact visual pill animation (philanthropy page) ──
  (function () {
    var pills = [1,2,3,4,5].map(function(i){ return document.getElementById('ip'+i); });
    var gift  = document.getElementById('igift');
    if (!pills[0]) return;
    var step = 0;
    function next() {
      pills.forEach(function(p, i) {
        if (p) p.classList.toggle('active', i < step);
      });
      if (gift) gift.classList.toggle('active', step >= 5);
      step = step >= 5 ? 0 : step + 1;
    }
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      // Render the settled end state once (all 5 pills + the gift active)
      // instead of looping the animation.
      step = 5;
      next();
      return;
    }
    next();
    setInterval(next, 700);
  })();

  // (Removed in Round 32) Dead testimonials-carousel block deleted: it
  // targeted #testimonialsTrack/#testimonialsDots, which exist only in an
  // orphaned section no template renders, and it carried an unthrottled
  // resize -> buildDots(); goTo(0) handler.

});

// ── Philanthropy video toggle ──────────────────────
function togglePhilVideo() {
  var v = document.getElementById('phil-video');
  var btn = document.getElementById('phil-video-btn');
  if (!v) return;
  if (v.paused) {
    v.play();
    if (btn) {
      btn.textContent = '⏸';
      // Video is now PLAYING
      btn.setAttribute('aria-label', 'Pause background video');
    }
  } else {
    v.pause();
    if (btn) {
      btn.textContent = '▶';
      // Video is now PAUSED
      btn.setAttribute('aria-label', 'Play background video');
    }
  }
}

// ── Cart AJAX ──────────────────────────────────
// Mirrors the default USD output of Liquid's `money` filter, e.g. $1,290.00
function apFormatMoney(cents) {
  var n = Math.round(cents);
  var sign = n < 0 ? '-' : '';
  var parts = (Math.abs(n) / 100).toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return sign + '$' + parts[0] + '.' + parts[1];
}

// Patch the cart page in place after /cart/change.js instead of reloading.
// Every selector below is taken from sections/main-cart.liquid. Returns false
// when a required hook is missing so the caller can fall back to a reload.
function apCartPatchDom(key, cart) {
  var row        = document.querySelector('.cart-item[data-key="' + key + '"]');
  var subtotalEl = document.getElementById('cart-subtotal-price');
  if (!row || !subtotalEl) return false;

  var line = null;
  for (var i = 0; i < cart.items.length; i++) {
    if (cart.items[i].key === key) { line = cart.items[i]; break; }
  }
  // Read the quantity back off the response — Shopify clamps to stock.
  if (!line) return false;

  var qtyNumEl = row.querySelector('.qty-num');
  if (qtyNumEl) qtyNumEl.textContent = line.quantity;
  var unitPriceEl = row.querySelector('.cart-item-price');
  if (unitPriceEl) unitPriceEl.textContent = apFormatMoney(line.price);
  var linePriceEl = row.querySelector('.cart-item-line-price');
  if (linePriceEl) linePriceEl.textContent = apFormatMoney(line.line_price);

  // The +/- buttons carry Liquid-baked quantities in their inline onclick, so
  // they must be re-pointed at the NEW quantity or the next tap sends a stale
  // value. Same for the minus button's label, which flips at quantity 1.
  var titleEl = row.querySelector('.cart-item-title');
  var title   = titleEl ? titleEl.textContent.trim() : 'item';
  var qtyBtns = row.querySelectorAll('.cart-item-qty .qty-btn');
  if (qtyBtns.length === 2) {
    qtyBtns[0].setAttribute('onclick', "cartUpdateQty('" + key + "', " + (line.quantity - 1) + ")");
    qtyBtns[0].setAttribute('aria-label', line.quantity === 1
      ? 'Remove ' + title + ' from cart'
      : 'Decrease quantity of ' + title);
    qtyBtns[1].setAttribute('onclick', "cartUpdateQty('" + key + "', " + (line.quantity + 1) + ")");
    qtyBtns[1].setAttribute('aria-label', 'Increase quantity of ' + title);
  }

  subtotalEl.textContent = apFormatMoney(cart.total_price);

  // Free-shipping progress bar. There is no longer a threshold: free U.S.
  // standard shipping applies to every order, so the bar always renders its
  // completed state.
  var progress = document.querySelector('.cart-ship-progress');
  if (progress) {
    var textEl = progress.querySelector('.cart-ship-progress-text');
    var fillEl = progress.querySelector('.cart-ship-progress-fill');
    progress.classList.add('is-complete');
    if (textEl) textEl.innerHTML = '<strong>Free U.S. standard shipping.</strong> Every order ships free, no code needed.';
    if (fillEl) fillEl.style.width = '100%';
  }

  apAnnounce(
    'Quantity ' + line.quantity + '. ' +
    cart.item_count + (cart.item_count === 1 ? ' item ' : ' items ') + 'in cart. ' +
    'Subtotal ' + apFormatMoney(cart.total_price) + '. ' +
    'Standard U.S. shipping is free on every order.'
  );
  return true;
}

// In-flight guard (Round 32): the +/- buttons carry Liquid-baked target
// quantities in their inline onclick, so a rapid double-tap sends the same
// target twice (lost update) and two racing POSTs can paint stale state.
// While a /cart/change.js request is in flight, further calls are dropped;
// the flag is cleared in the finally below. (Buttons are intentionally NOT
// visually disabled here, to keep the theme's disabled-count QA invariant.)
var apCartQtyInFlight = false;

function cartUpdateQty(key, qty) {
  if (apCartQtyInFlight) return;
  apCartQtyInFlight = true;
  if (qty < 0) qty = 0;
  var removing = qty === 0;
  apAnnounce(removing ? 'Removing item from cart' : 'Updating cart');
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) {
    // fetch() resolves on 4xx. The !cart.items guard below already caught the
    // error body, but it reloaded blind — the shopper saw the page flash and
    // never learned WHY. Surface the server's description, same as the add
    // path does.
    return r.json().catch(function() { return null; }).then(function(body) {
      if (!r.ok) {
        throw new Error((body && body.description) ||
          'Sorry, we could not update your cart. Please try again.');
      }
      return body;
    });
  })
  .then(function(cart) {
    if (!cart || !cart.items) { location.reload(); return; }
    updateCartCount(cart.item_count);
    // Success — clear any error box left over from a previous failed update.
    // #cart-error is rendered by sections/main-cart.liquid only; theme.js
    // runs sitewide, so its existence is guarded.
    var cartErrBox = document.getElementById('cart-error');
    if (cartErrBox) { cartErrBox.textContent = ''; cartErrBox.hidden = true; }
    // A removed line, or a cart that just went empty, renders a different
    // template (the cart-empty state), so a reload is the correct path there.
    if (removing || cart.item_count === 0) { location.reload(); return; }
    // Otherwise patch in place; reload only if a hook is missing.
    if (!apCartPatchDom(key, cart)) { location.reload(); }
  })
  .catch(function(err) {
    // Surface the failure in the visible #cart-error box (rendered by
    // sections/main-cart.liquid; guarded because theme.js runs sitewide) as
    // well as the #a11y-status live region. No automatic reload: the old 6s
    // timed location.reload() yanked focus and wiped the message mid-read for
    // screen-reader users. Instead the alert box gets an inline "Refresh cart"
    // link (href="" reloads the same URL) so the shopper re-syncs the page —
    // e.g. after a 404 on a line key removed in another tab — on their own
    // schedule.
    var msg = apFriendlyError(err && err.message,
      'Sorry, we could not update your cart. Please check your connection and try again.');
    apAnnounce(msg);
    var cartErrBox = document.getElementById('cart-error');
    if (cartErrBox) {
      cartErrBox.textContent = msg + ' ';
      var refreshLink = document.createElement('a');
      refreshLink.setAttribute('href', '');
      refreshLink.className = 'cart-error-refresh';
      refreshLink.textContent = 'Refresh cart';
      cartErrBox.appendChild(refreshLink);
      cartErrBox.hidden = false;
    }
  })
  .finally(function() {
    // Clear the in-flight guard on success AND failure.
    apCartQtyInFlight = false;
  });
}

function cartRemove(key) {
  cartUpdateQty(key, 0);
}

function updateCartCount(count) {
  var el = document.getElementById('cart-count');
  if (el) {
    el.textContent = count > 0 ? count : '';
    el.style.display = count > 0 ? 'flex' : 'none';
    // The cart link's accessible name is assembled from three text nodes in
    // layout/theme.liquid: "Cart," + this badge + a visually-hidden suffix
    // span that Liquid renders as "0 items" / "item" / "items". Patching only
    // the badge left that suffix frozen at whatever the page was rendered
    // with, so an AJAX add from 0 to 1 announced "Cart, 1 items". Keep the
    // two in agreement, matching the Liquid output exactly in each state.
    var suffix = el.nextElementSibling;
    if (suffix) {
      suffix.textContent = count === 1 ? 'item' : (count > 1 ? 'items' : '0 items');
    }
  }
}

// ── Add to Cart AJAX ────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('atc-btn');
      var stickyBtn = document.querySelector('#ap-sticky-atc .ap-sticky-atc-btn');
      // Rendered by sections/product-hero.liquid. #a11y-status is clipped to a
      // 1x1px box by round9.css block 9-0, so it is the ONLY thing a sighted
      // shopper can see when an add fails. Absent on other templates — every
      // use below is guarded.
      var errBox = document.getElementById('atc-error');
      var formData = new FormData(productForm);
      var qty = parseInt(formData.get('quantity')) || 1;
      var data = { items: [{ id: parseInt(formData.get('id')), quantity: qty }] };
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      if (stickyBtn) { stickyBtn.textContent = 'Adding...'; stickyBtn.disabled = true; }
      // Clear any error from a previous attempt so it cannot be misread as the
      // result of THIS one.
      if (errBox) { errBox.textContent = ''; errBox.hidden = true; }
      apAnnounce('Adding to cart');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function(r) {
        // fetch() resolves on 4xx, so an out-of-stock 422 would otherwise be
        // parsed, discarded, and painted as success. Surface the server's
        // description instead.
        return r.json().catch(function() { return null; }).then(function(body) {
          if (!r.ok) {
            throw new Error((body && body.description) ||
              'Sorry, we could not add that to your cart. Please try again.');
          }
          return body;
        });
      })
      .then(function() {
        // The add already succeeded. A failed /cart.js read must NOT be
        // reported as a failed add, or the shopper adds a second pillow.
        // Resolve null and let the guards below render a partial success.
        return fetch('/cart.js')
          .then(function(r) { return r.ok ? r.json() : null; })
          .catch(function() { return null; });
      })
      .then(function(cart) {
        var itemCount = cart ? cart.item_count : undefined;
        var hasCount = typeof itemCount === 'number' && isFinite(itemCount);
        if (hasCount) updateCartCount(itemCount);
        // Free U.S. standard shipping now applies to every order — no threshold,
        // no code, so the announced shipping line is constant.
        var shipMsg = 'Standard U.S. shipping is free on every order.';
        var countMsg = hasCount
          ? itemCount + (itemCount === 1 ? ' item ' : ' items ') + 'in cart. '
          : '';
        apAnnounce(
          qty + (qty === 1 ? ' pillow added to your cart. ' : ' pillows added to your cart. ') +
          countMsg +
          shipMsg
        );
        // Success — make sure no stale error is still on screen.
        if (errBox) { errBox.textContent = ''; errBox.hidden = true; }
        if (btn) {
          btn.textContent = 'Added ✓';
          setTimeout(function() { btn.textContent = 'ADD TO CART'; btn.disabled = false; }, 1800);
        }
        if (stickyBtn) {
          stickyBtn.textContent = 'Added ✓';
          setTimeout(function() { stickyBtn.textContent = 'ADD TO CART'; stickyBtn.disabled = false; }, 1800);
        }
      })
      .catch(function(err) {
        // err.message is truthy for a network rejection, so the old `||` never
        // fired and the browser's raw developer string was announced verbatim.
        var msg = apFriendlyError(err && err.message,
          'Sorry, we could not add that to your cart. Please check your connection and try again.');
        apAnnounce(msg);
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
        if (btn) { btn.textContent = 'ADD TO CART'; btn.disabled = false; }
        if (stickyBtn) { stickyBtn.textContent = 'ADD TO CART'; stickyBtn.disabled = false; }
      });
    });
  }
});

// ── Buy Now (add to cart then go straight to checkout) ──
// variantId is optional — if omitted, reads from the product form on the page
function buyNow(variantId) {
  var qty = 1;
  if (!variantId) {
    var form = document.getElementById('product-form');
    if (!form) { window.location = '/checkout'; return; }
    variantId = parseInt(form.querySelector('[name="id"]').value);
    qty = parseInt((form.querySelector('.qty-input') || {}).value) || 1;
  }
  // Show feedback on whichever button was clicked
  var clickedBtn = document.activeElement;
  var origText = clickedBtn ? clickedBtn.textContent : '';
  var errBox = document.getElementById('atc-error');
  if (clickedBtn && clickedBtn.tagName === 'BUTTON') { clickedBtn.textContent = 'Redirecting...'; clickedBtn.disabled = true; }
  if (errBox) { errBox.textContent = ''; errBox.hidden = true; }
  apAnnounce('Taking you to checkout');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
  })
  .then(function(r) {
    // Without this gate a 422 resolved and the shopper was sent to checkout
    // anyway, arriving with a cart that did not match what they tapped.
    return r.json().catch(function() { return null; }).then(function(body) {
      if (!r.ok) {
        throw new Error((body && body.description) ||
          'Sorry, we could not add that to your cart. Please try again.');
      }
      return body;
    });
  })
  .then(function() { window.location = '/checkout'; })
  .catch(function(err) {
    var msg = apFriendlyError(err && err.message,
      'Sorry, something went wrong. Please check your connection and try again.');
    apAnnounce(msg);
    if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
    if (clickedBtn && clickedBtn.tagName === 'BUTTON') { clickedBtn.textContent = origText; clickedBtn.disabled = false; }
  });
}


// ============================================================
// Block 29 (Round 29) -- scroll-reveal for section headings
// ============================================================
// Partner to round9.css block 29b. The CSS only hides headings
// when <html> carries .ap-reveal, and that class is added HERE,
// only after every bail-out has passed -- so without JavaScript,
// under prefers-reduced-motion, or in a browser lacking
// IntersectionObserver, nothing is ever hidden.
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Verified against the live sections this round -- see the
  // round9.css block 29b notes for the per-section mapping.
  var selector = '.section-title, .sci16-title, .hst-title, .story-title, .benefits-title';

  document.documentElement.classList.add('ap-reveal');

  function start() {
    var headings = document.querySelectorAll(selector);
    if (!headings.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ap-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    headings.forEach(function (h) { observer.observe(h); });
  }

  // theme.js is loaded at the end of <body> (layout/theme.liquid:355),
  // so the DOM is normally already parsed; the listener is a fallback.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
